import { FinancialAdvisorProRoute } from '@/modules/financialadvisor/constants/FinancialAdvisorProRoute';
import { FinancialAdvisorProRouteConfig } from '@/modules/financialadvisor/routes/FinancialAdvisorProRouteConfig';

export const router = [
  FinancialAdvisorProRouteConfig.factory({
    path: `/${FinancialAdvisorProRoute.OPPORTUNITIES.path}`,
    name: FinancialAdvisorProRoute.OPPORTUNITIES.name,
    component: () =>
      import('@/modules/financialadvisor/pages/FinancialAdvisorProOpportunitiesPage.vue'),
    meta: { authOnly: true }
  }).build()
];
